<template>
  <Content @back="$router.go(-1)" :noBack="userRole === 'expert'">
    <template v-slot:nav_left>
      <div>
        <span class="navTitle" @click="jumpTo('/siteFacilities/list')">机构场地管理</span>
        <span class="navTitle active">辅助配套设施</span>
      </div>

    </template>
    <template v-slot:content_right>
      <div class="select_wrap">
        <div class="remember">
          <p>
          <!--<span style="margin-right:7px;color:red">* 运动员一条龙升学通道布局情况，原则上，男足应形成“631”培养体系，女足应形成“321”培养体系。</span>-->
          </p>
        </div>
        <div class="select_box">
          <select v-model="selectVal.organUuid" class="yioks_select" @change="changeSelectOrg" >
            <option v-if="selectOrganList.length > 1" value=''>全部区体育行政部门</option>
            <option
              v-for="item in selectOrganList"
              :key="item.organUuid"
              :value="item.organUuid"
            >{{ item.organShortName }}</option>
          </select>
          <select v-model="selectVal.youthUuid" class="yioks_select" @change="changeQuery(true)" >
            <option v-if="selectCenterList.length !== 1" value=''>全部培训机构</option>
            <option
              v-for="item in selectCenterList"
              :key="item.uuid"
              :value="item.uuid"
            >{{ item.youthShortName }}</option>
          </select>
        </div>
        <!--<div class="search_box">-->
          <!--<input-->
            <!--v-model.trim="selectVal.keyWord"-->
            <!--type="text"-->
            <!--class="yioks_input"-->
            <!--placeholder="请输入关键词"-->
            <!--@keyup.enter="changeQuery(true)"-->
          <!--&gt;-->
          <!--<div class="yioks_btn" @click="changeQuery(true)">搜索</div>-->
        <!--</div>-->
      </div>
      <div class="list_wrap">
        <div v-if="showList" class="table">
          <div class="thead">
            <div class="tr">
              <div class="th seq"><strong>序号</strong></div>
              <div class="th idName"><strong>管理单位</strong></div>
              <div class="th unionName"><strong>机构 / 青训中心</strong></div>
              <div class="th opt"><strong>操作</strong></div>
            </div>
          </div>
          <div class="scrollArea">
            <vue-scroll >
              <div class="tbodyWrap">
                <div class="tbody">
                  <div
                    v-for="(item, index) in squadList"
                    :key="index"
                    class="tr">
                    <div class="td seq">
                      <p>{{ index + 1 }}</p>
                    </div>
                    <div class="td idName" :title="item.organShortName">
                      <p>{{ item.organShortName || '--' }}</p>
                    </div>
                    <div class="td unionName" :title="item.youthShortName">
                      <p>{{ item.youthShortName || '--' }}</p>
                    </div>
                    <div class="td opt">
                      <p>
                        <span class="item" @click="goDetail(item.youthUuid)">查看</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
        <yioks-loading v-if="loading" />
        <yioks-empty v-if="empty"
          tips="暂时没有数据"
        ></yioks-empty>
      </div>
      <Pagination :total="total" :page.sync="page" />
      <yioks-dialog
        :title="'辅助配套设施——'+schoolInfo.youthShortName"
        :show-flag="isShowDialog"
        :isShowCancel="false"
        :width="'860px'"
        :successBtn="'关闭'"
        @hideDialog="hideDialogFunction"
      >
        <div class="dialog-content ">
          <vue-scroll :ops="ops">
            <div>
            </div>
            <div class="info">
              <div class="col">
                <span class="title">场地是否安装高清视频系统，无线网络覆盖场地：{{schoolInfo.videoSystem | checkStatus}}</span>
                <div v-for="(item, index) in videoSystemFileList" class="fileCol">
                  <span>证明材料{{index+1}}：
                  <a
                    :href="$yioksConfig.transferBaseOnly(item.fileUrl)"
                    target="_blank"
                    :title="item.fileName"
                    style="font-size: 16px;line-height: 1.2em;color:#4cd964"
                  >{{ item.fileName }}</a></span>
                </div>
              </div>
              <div class="col">
                <span class="title">引入EPTS（电子表现跟踪系统）：{{schoolInfo.expressionSystem | checkStatus}}</span>
                <div v-for="(item, index) in expressionSystemFileList" class="fileCol">
                  <span>证明材料{{index+1}}：
                  <a
                    :href="$yioksConfig.transferBaseOnly(item.fileUrl)"
                    target="_blank"
                    :title="item.fileName"
                    style="font-size: 16px;line-height: 1.2em;color:#4cd964"
                  >{{ item.fileName }}</a></span>
                </div>
              </div>
              <div class="col">
                <span class="title">场地附近有运动员更衣室、淋浴间、体能训练房等功能房和设施：{{schoolInfo.changingRoom | checkStatus}}</span>
                <div v-for="(item, index) in changingRoomFileList" class="fileCol">
                  <span>证明材料{{index+1}}：
                  <a
                    :href="$yioksConfig.transferBaseOnly(item.fileUrl)"
                    target="_blank"
                    :title="item.fileName"
                    style="font-size: 16px;line-height: 1.2em;color:#4cd964"
                  >{{ item.fileName }}</a></span>
                </div>
              </div>
              <div class="col">
                <span class="title">设立医务室，配备AED设备，与就近的周边医院建立绿色通道：{{ schoolInfo.dispensary | checkStatus}}</span>
                <div v-for="(item, index) in dispensaryFileList" class="fileCol">
                  <span>证明材料{{index+1}}：
                  <a
                    :href="$yioksConfig.transferBaseOnly(item.fileUrl)"
                    target="_blank"
                    :title="item.fileName"
                    style="font-size: 16px;line-height: 1.2em;color:#4cd964"
                  >{{ item.fileName }}</a></span>
                </div>
              </div>
              <div class="col">
                <span class="title">各场地周边应配备行政用房 ：{{schoolInfo.occupancy | checkStatus}}</span>
                <div v-for="(item, index) in occupancyFileList" class="fileCol">
                  <span>证明材料{{index+1}}：
                  <a
                    :href="$yioksConfig.transferBaseOnly(item.fileUrl)"
                    target="_blank"
                    :title="item.fileName"
                    style="font-size: 16px;line-height: 1.2em;color:#4cd964"
                  >{{ item.fileName }}</a></span>
                </div>
              </div>
              <div class="col">
                <span class="title">有容纳50人以上的现代化多媒体教室 ：{{schoolInfo.classroom | checkStatus}}</span>
                <div v-for="(item, index) in classroomFileList" class="fileCol">
                  <span>证明材料{{index+1}}：
                  <a
                    :href="$yioksConfig.transferBaseOnly(item.fileUrl)"
                    target="_blank"
                    :title="item.fileName"
                    style="font-size: 16px;line-height: 1.2em;color:#4cd964"
                  >{{ item.fileName }}</a></span>
                </div>
              </div>
            </div>
          </vue-scroll>
        </div>
      </yioks-dialog>
    </template>
  </Content>
</template>

<script>

  import 'vue-awesome/icons/plus'
  import 'vue-awesome/icons/regular/trash-alt'
  import 'vue-awesome/icons/regular/edit'
  import siteFacilities from '@/api/siteFacilities'
  import coach from '@/api/coach'
  import scoreImg from '@/assets/images/common/squad.png'
  import storage from '@/utils/storage'
  import squadFormRule from '@/utils/formRules/squad'
  import { ops } from '@/utils/scrollIndialog'
  import { footballType,propertyTypeList } from '@/utils/yioks_data'
  export default {
    components: {
      'Content': () => import('@/components/layout/list'),
      'Pagination': () => import('@/components/Pagination'),
      'AddSquadDialog': () => import('@/components/siteFacilities')
    },
    mixins: [squadFormRule],
    data () {
      return {
        footballType,
        propertyTypeList,
        ops,
        isShowDialog: false,
        squadList: [],
        addSquad: false,
        addbtnLoading: false,
        isEdit: false,
        userRole: storage.get('userInfo').userRole,
        uuid: storage.get('userInfo').uuid,
        squadUuid: '',
        total: 0,
        pageSize: 20,
        page: 0,
        empty: false,
        showList: false,
        scoreImg,
        showTip: false,
        squadNameList: [],
        loading: true,
        squadName: '',
        centerList: [],
        organList: [],
        selectCenterList: [],
        selectOrganList: [],
        uploadFileList: [],
        videoSystemFileList: [],
        expressionSystemFileList: [],
        changingRoomFileList: [],
        dispensaryFileList: [],
        occupancyFileList: [],
        classroomFileList: [],
        schoolInfo:{},
        selectVal: {
          organUuid: '',
          youthUuid: '',
          keyWord: '',
          siteType: '',
          propertyType: '',
        },
        typeIdx: 0,
        navIdx: Number(this.$route.query.idx) ? Number(this.$route.query.idx) : 0,
      }
    },
    watch: {
      page () {
        this.changeQuery()
      }

    },
    created () {
      const { page, keyWord, organUuid, youthUuid,siteType,propertyType } = this.$route.query
      page && (this.page = Number(page))
      keyWord && (this.$set(this.selectVal, 'keyWord', keyWord))
      organUuid && (this.$set(this.selectVal, 'organUuid', organUuid))
      youthUuid && (this.$set(this.selectVal, 'youthUuid', youthUuid))
      siteType && (this.$set(this.selectVal, 'siteType', siteType))
      propertyType && (this.$set(this.selectVal, 'propertyType', propertyType))
      this.getOrganListAndCenterList()
      this.getSquadList()
    },
    filters: {
      checkStatus(val) {
        let res = '否';
        switch(val) {
          case true:
            res = '是';
            break;
          case false:
            res = '否';
            break;
          default:
            res = '--';
            break;
        }
        return res;
      },
    },
    methods: {
      jumpTo(path) {
        if(this.userRole === 'expert'){
          this.$router.replace({
            path: path,
            query: {
              organUuid:this.selectVal.organUuid,
              youthUuid:this.selectVal.youthUuid,
            },
          });
        }else{
          this.$router.replace(path)
        }
      },
      checkDownload (fileName) {
        let patten = /\.(jpg|jpeg|gif|bmp|png|pdf)$/i
        return patten.test(fileName)
      },
      hideDialogFunction (flag, ok) {
        if (ok) {
          this.isShowDialog = flag
        } else {
          this.isShowDialog = flag
        }
      },
      getSquadList () {
        this.loading = true
        this.empty = false
        this.showList = false
        let request
        if (this.userRole === 'system' || this.userRole === 'admin' || this.userRole === 'expert' || this.userRole === 'organ') {
          request = siteFacilities.assistListSystem
        }
        request({
          page: this.page,
          size: this.pageSize,
          key: this.selectVal.keyWord,
          organUuid: this.selectVal.organUuid,
          youthUuid: this.selectVal.youthUuid,
        }).then((res) => {
          this.loading = false
          this.total = res.totalElements
          if (res.content.length) {
            this.squadList = res.content
            this.showList = true
          } else {
            this.empty = true
          }
        }).catch(err => {
          this.loading = false
          console.error(err)
        })
      },
      deleteSquad (uuid) {
        this.showTip = true
        this.delUuid = uuid
      },
      isDelete (isSure) {
        if (isSure) {
          siteFacilities.deleteFootball(this.delUuid).then(res => {
            this.showTip = false
            this.getSquadList()
          })
        } else {
          this.showTip = false
        }
      },
      editSquad (uuid) {
        this.squadUuid = uuid
        this.addSquad = true
        this.isEdit = true
      },
      goDetail (uuid) {
        siteFacilities.assistInfoSystem(uuid).then(res => {
          this.schoolInfo = res.facilityAssist
          this.videoSystemFileList=[];
          this.expressionSystemFileList=[];
          this.changingRoomFileList=[];
          this.dispensaryFileList=[];
          this.occupancyFileList=[];
          this.classroomFileList=[];

          if (res.contractList && res.contractList.length) {
            res.contractList.map(item=>{
              switch(item.facilityType) {
                case 'videoSystem': this.videoSystemFileList.push(item); break;
                case 'expressionSystem': this.expressionSystemFileList.push(item); break;
                case 'changingRoom': this.changingRoomFileList.push(item); break;
                case 'dispensary': this.dispensaryFileList.push(item); break;
                case 'occupancy': this.occupancyFileList.push(item); break;
                case 'classroom': this.classroomFileList.push(item); break;
              }
            })
          }
        })
        this.isShowDialog= true
      },
      hideAddsquadDialog (flag) {
        this.isEdit = false
        this.addSquad = flag
        this.getSquadList()
      },
      // getOrganListAndCenterList (geList) {
      getOrganListAndCenterList () {
        let data = this.uuid
        let request
        if (this.userRole === 'organ') {
          request = coach.getCenterListByOrgan
        } else if (this.userRole === 'system' || this.userRole === 'admin' || this.userRole === 'expert') {
          request = coach.getCenterListBySystem
          data = ''
        } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
          request = coach.getCenterListByYouth
        }
        request(data).then((res) => {
          this.organList = res
          this.selectOrganList = res
          if (this.organList.length === 1) {
            this.$set(this.selectVal, 'organUuid', this.organList[0].organUuid)
            this.selectCenterList = this.selectOrganList.find(item => {
              return item.organUuid === this.selectVal.organUuid
            }).youthList || []
            if (this.selectCenterList.length === 1) {
              this.$set(this.selectVal, 'youthUuid', this.selectCenterList[0].uuid)
            }
          }
          this.selectVal.organUuid && this.setCenterList()
          // geList()
        })
      },
      setCenterList () {
        this.selectCenterList = this.selectOrganList.find(item => {
          return item.organUuid === this.selectVal.organUuid
        }).youthList || []
        this.centerList = this.selectCenterList
      },
      changeQuery (flag) {
        if (flag) this.page = 0
        this.$router.replace({
          path: this.$route.path,
          query: {
            page: this.page,
            keyWord: this.selectVal.keyWord,
            youthUuid: this.selectVal.youthUuid,
            organUuid: this.selectVal.organUuid,
            siteType: this.selectVal.siteType,
            propertyType: this.selectVal.propertyType,
          }
        })
        this.getSquadList()
      },
      changeSelectOrg () {
        this.$set(this.selectVal, 'youthUuid', '')
        if (this.selectVal.organUuid) {
          this.selectCenterList = this.selectOrganList.find(item => {
            return item.organUuid === this.selectVal.organUuid
          }).youthList || []
          if (this.selectCenterList.length === 1) {
            this.$set(this.selectVal, 'youthUuid', this.selectCenterList[0].uuid)
          }
        } else {
          this.selectCenterList = []
          this.$set(this.selectVal, 'youthUuid', '')
        }
        this.changeQuery(true)
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .select_wrap {
    position: relative;

    .yioks_select{
      width:130px
    }
    .remember {
      position: absolute;
      top: -22px;
      right: 0;
      color: #4cd964;
      font-weight: bold;

      a {
        color: #4cd964;
      }
    }
  }
  .navTitle
    padding 10px 20px
    /*margin-right .2rem*/
    cursor pointer
    &:last-child
    &:last-child
      margin-right 0
    &.active
      background $green_color
      color #FFF
  .list_wrap
    flex 1
    overflow hidden
    .table {
      display flex
      flex-direction column
      flex 1
      width: 100%;
      // margin: 30px 0 0;
      .thead, .tbody {
        border: 1px solid $color_white;
      }
      .thead {
        margin: 0 40px;
        .tr {
          height: 45px;
          display: flex;
        }
      }
      .scrollArea {
        height: 425px;
        padding-bottom 15px
        /*flex 1 */
        /*overflow hidden*/
      }
      .tbodyWrap {
        display block
        // padding: 0 40px;
      }
      .tbody {
        display block
        width 810px
        margin-left auto
        margin-right auto
        max-width: 810px;
        border-top: none;
        border-bottom: none;
        .tr {
          height: 49px;
          display: flex;
          border-bottom: 1px solid $color_white;
        }
      }
      .th, .td {
        height: 100%;
        /*flex: 1 1 auto;*/
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: $font_size_medium;
        border-right: 1px solid $color_white;
      }
      .th:last-child, .td:last-child {
        border-right: none;
      }
      .td {
        p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: $color_white;
        }
      }
      .unionName{
        width 55%
        p {
          padding 0 4px
        }
      }
      .seq {
        width 5%
      }
      .idName{
        width 25%
      }

      .opt{
        width: 15%;
        p{
          width 100%
          text-align center
          .item{
            cursor: pointer;
            user-select: none;
            color $green_color
          }
          .split{
            margin 0 5px
          }
        }
      }
      .squadDissolve{
        color: #f88594 !important
      }
    }
  .coachLimit
    color #f88594 !important
  .demo-ruleForm
    height 475px
  .tip
    margin-top 10px
    color red
    width 100%
    text-align center
    word-break break-word
  .dialog-content
    width 100%
    height 420px
    padding 10px 0px 20px
    .info
      flex 1
      border 1px solid #4cd964
      border-bottom: none
      margin-right 30px
    .col
      border-bottom 1px solid #4cd964
      // border-right 1px solid #FFF
      padding 16px 15px
      display block
      justify-content space-around
      span
        display inline-block
        width 100%
      .fileCol
        margin-top 10px
      .title
        font-size 16px
        font-weight bold

</style>

